export default {
    url: 'https://github.com/login/oauth/authorize',

    params: {
        client_id: '054e29a7222ec7086b7c',
        redirect_uri: 'login/github',
        response_type: 'code',
        scope: 'user:email',
        state: {},
    }
}
